/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import getConfig from 'next/config';
import { useAuth } from 'root/hooks/useAuth';
import PostCard from 'components/PostCard';
import apiClient from '../../lib/apiClient';

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const RecommendContentWidget = ({ widget }) => {
  const post_count = widget.content.length;

  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  if (post_count >= 2) {
    return (
      <div className="related-posts">
        <div className="section-title">
          <span className="label titles-color text-uppercase">{widget.options.title}</span>
        </div>
        <section id="latest-posts-widget" className="widget posts-style-9">
          <div className="posts-row">
            {widget.content.map((post, index) => (
              <PostCard
                key={post.id}
                post={post}
                big={index === 0}
                height={{ desktop: '220px', mobile: '135px' }}
                lazy
                isAuthenticated={isAuthenticated}
                bookmarks={bookmarks}
                handleBookmarks={setBookmarks}
              />
            ))}
          </div>
        </section>
      </div>
    );
  }

  return null;
};

RecommendContentWidget.propTypes = {
  widget: PropTypes.object,
};

export default RecommendContentWidget;
